<template>
  <div class="label" :class="[`color-${color}`]">
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps<{ color: "blue" | "green" }>();
</script>

<style lang="scss" scoped>
.label {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 18px;

  &.color-blue {
    background-color: $extra-light-blue;
    color: $main-blue;
    border: 1px solid $main-blue;
  }

  &.color-green {
    background-color: $main-green;
    color: $white;
  }
}
</style>
